const initialState = {
  questions: null,
  loading: true,
  search: null,
  isReportModalOpen:false
};

const questionBankReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "ADD_QUESTIONS": {
      return {
        ...state,
        questions: actions.questions,
        loading: actions.loading,
        ...actions.data,
      };
    }
    case "ADD_MORE": {
      return {
        ...state,
        questions: [...actions.questions, ...state.questions],
      };
    }
    case "UPDATE": {
      return { ...state, questions: actions.questions };
    }
    case "RESET_INITIAL_DATA": {
      return { ...state, questions: [], totalItems: "", totalPages: "" };
    }
    case "Loading": {
      return { ...state, loading: true };
    }
    case "SET_SEARCH": {
      return { ...state, search: actions.data };
    }
    case "CLEAR_SEARCH": {
      return { ...state, search: null };
    }

    case "SET_QUESTION_DATA": {
      return { ...state, ...actions.payload };
    }
    case "QUESTION_INITIATE": {
      return { ...state, fetching: true, fetched: false,...actions.payload }
    }
    case "QUESTION_TERMINATE": {
      return { ...state, fetching: false, fetched: true, ...actions.payload }
    }

    default:
      return state;
  }
};
export default questionBankReducer;
